import React from "react";
import classes from "./HeroSection.module.scss";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import CustomImage from "../../CustomImage";
import useIsMobile from "../../../hooks/useIsMobile";
import Kunai from "../../UI/Icons/Kunai";
import { isFrappeOrJotFormClass } from "../../../utils/helpers";

const HeroSection = ({ scholarshipData }: any) => {
  const isMobile = useIsMobile(768);

  return (
    <section className={classes["hero-section-wrapper"]}>
      <div id="sholarships-page" className={classes.heroSection}>
        <div className={classes["hero-content"]}>
          <div className={classes["breadcrum-container"]}>
            <Breadcrumb>
              <Breadcrumb.Item style={{ opacity: 0.5 }} href="/">
                Home
              </Breadcrumb.Item>
              <Breadcrumb.Item href="">Scholarships</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <h1>{scholarshipData?.heroSection?.title}</h1>
          <p>{scholarshipData?.heroSection?.description}</p>
          <button className={`${classes["cta-button"]} ${isFrappeOrJotFormClass(scholarshipData?.meta?.jotforms[0]?.jotformid ?? "")}`}>
            {scholarshipData?.heroSection?.ctaBtn?.btnTitle}
          </button>
        </div>
        <div className={classes["images-container"]}>
          <div className={classes["bg-circle"]}></div>
          <div className={classes["column-1"]}>
            <div className={classes["image-container-1"]}>
              <CustomImage
                src={scholarshipData?.heroSection?.imageUrl1}
                alt={scholarshipData?.heroSection?.image1Alt ?? "hero-img"}
                width={isMobile ? 146 : 200}
                height={isMobile ? 119 : 160}
                objectFit="fill"
              />
            </div>
            <div className={classes["image-container-2"]}>
              <CustomImage
                src={scholarshipData?.heroSection?.imageUrl3}
                alt={scholarshipData?.heroSection?.image3Alt ?? "hero-img"}
                objectFit="fill"
                width={isMobile ? 146 : 200}
                height={isMobile ? 167 : 230}
              />
            </div>
          </div>
          <div className={classes["column-2-wrapper"]}>
            <div className={classes["column-2"]}>
              <div className={classes["image-container-1"]}>
                <CustomImage
                  src={scholarshipData?.heroSection?.imageUrl2}
                  alt={scholarshipData?.heroSection?.image2Alt ?? "hero-img"}
                  width={isMobile ? 146 : 205}
                  height={isMobile ? 167 : 235}
                  objectFit="fill"
                />
              </div>
              <div className={classes["image-container-2"]}>
                <CustomImage
                  src={scholarshipData?.heroSection?.imageUrl4}
                  alt={scholarshipData?.heroSection?.image4Alt ?? "hero-img"}
                  width={isMobile ? 146 : 205}
                  height={isMobile ? 119 : 168}
                  objectFit="fill"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {isMobile && (
        <div className={classes["star-container-layer"]}>
          <div className={classes["star-1"]}>
            <Kunai />
          </div>
          <div className={classes["star-2"]}>
            <Kunai />
          </div>
          <div className={classes["star-3"]}>
            <Kunai color="#ffffff80" />
          </div>
          <div className={classes["empty-hole"]}></div>
          <div className={classes["dot-1"]}></div>
          <div className={classes["dot-2"]}></div>
        </div>
      )}
    </section>
  );
};

export default HeroSection;
